export default "__VITE_ASSET__CO08OdG$__"